import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

const ITEM_WIDTH = 232;

@Component({
  selector: 'app-available-classes-slider',
  templateUrl: './available-classes-slider.component.html',
  styleUrls: ['./available-classes-slider.component.scss']
})
export class AvailableClassesSliderComponent implements OnInit {

  @Input('specialityCategoryList') specialityCategoryList;

  @ViewChild("slider", { static: false }) slider;

  allClassesActiveTab = 1
  scrollPos = 0;

  constructor(
    private router: Router,
  ) { }

  ngOnInit(): void {
  }

  get sliderElement() {
    return this.slider.nativeElement as HTMLDivElement
  }

  sliderPrev() {
    this.scrollPos -= ITEM_WIDTH;
    if (this.scrollPos < 0) this.scrollPos = 0;
    this.sliderElement.scrollTo({ left: this.scrollPos })

  }

  sliderNext(itemCount: number) {
    this.scrollPos += ITEM_WIDTH;
    if (this.scrollPos > (ITEM_WIDTH * itemCount)) this.scrollPos = ITEM_WIDTH * itemCount;
    this.sliderElement.scrollTo({ left: this.scrollPos })
  }

  onNavChange() {
    this.scrollPos = 0;
  }

  searchClass(categoryId, specialityId = '') {
    this.router.navigate([`search-class-results` + `/` + categoryId + `/` + specialityId]);
  }

}
